import { AdditionalEquipment } from './AdditionalEquipment';
import QuoteHandset from './QuoteHandset';

export class Quote {
  constructor({
    orderID = null,
    type = 1,
    isGrouped = 1,
    currentSpend = [],
    channelInstallation = [],
    additionalEquipments = [],
    contractorDetails = null,
  } = {}) {
    this.orderID = orderID;
    this.type = type;
    this.isGrouped = isGrouped;
    this.currentSpend = currentSpend;
    this.channelInstallation = channelInstallation;
    this.additionalEquipments = additionalEquipments;
    this.contractorDetails = contractorDetails;
  }
}

export function createQuote(data) {
  return Object.freeze(new Quote(data));
}
